export function LabelStyle() {
  return {
    color: () => {
      return "primary";
    },
    fontSize: "11px",
    position: "absolute",
    marginTop: "-6px",
    marginLeft: "4px",
    alignSelf: "flex-start",
    pt: "6px",
    px: "2",
    transition: "150ms ease-in-out all",
    zIndex: 1,
  };
}
